import React from 'react';
import TaskFormProps from '../TaskFormProps';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Grid, TextField } from '@material-ui/core';
import ProcessStore from '../../../../../../../../data/store/pageStore/design/ProcessStore';
import QCExperiment from '../../../../../../../../data/model/design/taskDatas/qc/QCexperiment';
import TitledPaper from '../../../../../../../common/component/TitledPaper';
import FormUtil from '../../../../../../../../module/FormUtil';
import FormButtonSet from '../../../../../../../common/component/FormButtonSet';
import PTSMessage from '../../../../../../../../data/model/common/PTSMessage';
import Helper from '../../../../../../../../module/Helper';
import Validatable from '../../../../../../../../data/model/common/Validatable';

interface Props extends TaskFormProps {
}

@inject('rootStore')
@observer
class QCExperimentForm extends React.Component<Props> {
    globalStore = this.props.rootStore.globalStore;
    store = observable(new ProcessStore<QCExperiment>());

    constructor(props: Props) {
        super(props);
        this.store.taskData.detail = new QCExperiment();
        this.props.rootStore.commentStore.stage = 'QC 실험';
    }

    componentDidMount = async () => {
        try {
            this.globalStore.isRunning = true;
            const workInfo = this.props.workInfo;
            this.store.workInfo = workInfo;
            this.store.taskData._id = (workInfo.taskList[0] as any)._id;
            this.store.taskData.workID = (workInfo.taskList[0] as any).workID;
        } catch (err) {
            if (err instanceof PTSMessage) {
                alert(err.message);
            }
        } finally {
            this.globalStore.isRunning = false;
        }
    }

    onFormSubmit = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        try {
            if (!window.confirm('제출하시겠습니까?')) {
                return;
            }
            this.globalStore.isRunning = true;

            this.props.postTaskData(this.store.taskData);
        } catch (err) {

        } finally {
            this.globalStore.isRunning = false;
        }
    }

    onValidate = () => {
        this.store.taskData.detail.initErrorsRecursive();
        this.store.taskData.detail.resetErrorsRecursive();
        this.store.taskData.detail.validateRecursive();
        this.store.isValid = !this.store.taskData.detail.hasErrorRecursive();
        if (!this.store.isValid) {
            alert(Validatable.errorTexts.notValid);
        }
    }

    onFormClear = () => {
        window.location.reload();
    }

    render() {
        return (
            <React.Fragment>
                <Grid item container>
                    <Grid item xl lg sm>
                        <TitledPaper title='실험데이터'>
                            <TextField
                                fullWidth
                                margin='normal'
                                value={this.store.taskData.detail.QCprobeConc || ''}
                                name='QCprobeConc'
                                type='number'
                                onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
                                onChange={this.store.taskData.detail.onChangeDefault}
                                label={FormUtil.getFieldLabel('QCprobeConc')}
                                helperText={
                                    Helper.getErrorText(
                                        this.store.taskData.detail.errors.QCprobeConc
                                    )
                                }
                                error={
                                    Helper.getErrorState(
                                        this.store.taskData.detail.errors.QCprobeConc
                                    )
                                } />
                            <TextField
                                fullWidth
                                margin='normal'
                                value={this.store.taskData.detail.dilFactor || ''}
                                type='number'
                                name='dilFactor'
                                onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
                                onChange={this.store.taskData.detail.onChangeDefault}
                                label={FormUtil.getFieldLabel('dilFactor')}
                                helperText={
                                    Helper.getErrorText(
                                        this.store.taskData.detail.errors.dilFactor
                                    )
                                }
                                error={
                                    Helper.getErrorState(
                                        this.store.taskData.detail.errors.dilFactor
                                    )
                                } />
                        </TitledPaper>
                    </Grid>
                </Grid>
                <Grid item xl lg sm>
                    <FormButtonSet
                        validated={this.store.isValid}
                        onFormClear={(e) => this.onFormClear()}
                        onSubmit={(e) => this.onFormSubmit(e)}
                        onValidate={(e) => this.onValidate()}
                    />
                </Grid>
            </React.Fragment>
        )
    }
}

export default QCExperimentForm;